import React from 'react';
import { Modal, Form, Select, Checkbox, Button, Space } from 'antd';
import { subjectOptions, competitionTypeOptions } from '../../../core/utils/helpers';

const { Option } = Select;

export interface CompetitionFilters {
    subjects: string[];
    types: string[];
    imported: string | null;
}

interface CompetitionFilterModalProps {
    visible: boolean;
    onCancel: () => void;
    onApply: (filters: CompetitionFilters) => void;
    currentFilters: CompetitionFilters;
}

const CompetitionFilterModal: React.FC<CompetitionFilterModalProps> = ({
    visible,
    onCancel,
    onApply,
    currentFilters,
}) => {
    const [form] = Form.useForm();

    const handleApply = () => {
        const values = form.getFieldsValue();
        onApply({
            subjects: values.subjects || [],
            types: values.types || [],
            imported: values.imported,
        });
    };

    const handleReset = () => {
        form.resetFields();
        onApply({
            subjects: [],
            types: [],
            imported: null,
        });
    };

    return (
        <Modal
            title="Filtruoti konkursus"
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="reset" onClick={handleReset}>
                    Išvalyti
                </Button>,
                <Button key="cancel" onClick={onCancel}>
                    Atšaukti
                </Button>,
                <Button key="apply" type="primary" onClick={handleApply}>
                    Taikyti
                </Button>,
            ]}
            width={500}
            destroyOnClose>
            <Form
                form={form}
                layout="vertical"
                initialValues={currentFilters}>
                <Form.Item
                    name="subjects"
                    label="Dalykai">
                    <Select
                        mode="multiple"
                        placeholder="Pasirinkite dalykus"
                        allowClear
                        style={{ width: '100%' }}>
                        {subjectOptions.map(subject => (
                            <Option key={subject.value} value={subject.value}>
                                {subject.label}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    name="types"
                    label="Konkursų tipai">
                    <Select
                        mode="multiple"
                        placeholder="Pasirinkite tipus"
                        allowClear
                        style={{ width: '100%' }}>
                        {competitionTypeOptions.map(type => (
                            <Option key={type.value} value={type.value}>
                                {type.label}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    name="imported"
                    label="Importuotas">
                    <Select
                        placeholder="Pasirinkite importavimo statusą"
                        allowClear
                        style={{ width: '100%' }}>
                        <Option value="true">Taip</Option>
                        <Option value="false">Ne</Option>
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CompetitionFilterModal;
